import angular from 'angular';

angular.module('cloudX').directive('cxImageLoader', function() {
  return {
    restrict: 'A',
    link: function(scope, element) {
      var el = angular.element(
        '<div class="spinner">' +
          '<div class="bounce1"></div>' +
          '<div class="bounce2"></div>' +
          '<div class="bounce3"></div>' +
          '</div>',
      );
      el.insertAfter(element);
      element.on('loadstart', function() {
        if (element) element.hide();
        if (el) el.show();
      });
      element.on('load', function() {
        if (element) element.show();
        if (el) el.hide();
      });

      element.on('$destroy', function() {
        if (el) el.remove();
        el = null;
      });
    },
  };
});
